// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import createReactClass from 'create-react-class';
import {Spec} from 'immutability-helper';
import React from 'react';
import _ from 'underscore';

import {assert} from 'Asserts';
import {EntryProtocol} from 'notebook/ELNConstants';
import wyciwyp from 'notebook/mediocre/clipboard/wyciwyp';
import EditableComponent, {EditableProps} from 'notebook/mediocre/core-ui/EditableComponent';
import {SelectionPartition} from 'notebook/mediocre/EditorTypes';
// @ts-expect-error module still JS
import formatters from 'notebook/mediocre/formatted-text/formatters';
import {Format} from 'notebook/mediocre/formatted-text/FormattersConstants';
import EditableList from 'notebook/mediocre/selection/text/EditableListMixin';
// @ts-expect-error module still JS
import * as selutil from 'notebook/mediocre/selection/text/SelUtil';
import * as StepConstants from 'notebook/protocols/StepConstants';
import {ElementClipboardEvent, ElementKeyboardEvent} from 'util/Types';

function IntroEditable(props: EditableProps<number>): JSX.Element {
  return (
    <EditableComponent
      // eslint-disable-next-line no-restricted-syntax
      {..._.extend({}, props, {
        allowRichText: true,
        allowMultiline: true,
        spellCheck: props.spellCheck,
      })}
    />
  );
}

interface IntroEditorProps {
  jumpTo: (args: {
    section: StepConstants.EditorKey;
    row: 'first' | 'last';
    location: 'start' | 'end';
  }) => void;
  // required for mixing in EditableList, but not used within IntroEditor overrides
  metadataForRestore: {selection: BenchlingSelection | null};
  protocol: EntryProtocol;
  spellCheck: boolean;
  // omitted if locked
  updateProtocol?: (protocol: EntryProtocol, op: Spec<EntryProtocol>) => void;
}

interface IntroEditorState {
  index: number;
}

// oxlint-disable-next-line react/prefer-es6-class
const IntroEditor = createReactClass<IntroEditorProps, IntroEditorState>({
  mixins: [EditableList],

  getIntro(): string {
    return this.props.protocol.description;
  },

  setIntro(text: string, formats: Format): void {
    assert(text != null && formats != null, 'You must set intro and formats together');
    this.props.updateProtocol({
      description: text,
      descriptionFormats: formats,
    });
  },

  moveHandler(e: {up: boolean; beginning: boolean}): void {
    const {up, beginning} = e;
    this.clearSelection();
    const location = beginning ? 'start' : 'end';
    const row = up ? 'last' : 'first';
    const section = up ? StepConstants.EditorKey.TITLE : StepConstants.EditorKey.MATERIALS;
    this.props.jumpTo({section, location, row});
  },

  updateHandler(e: {
    text: string;
    target: Element | EventTarget;
    formats: Format;
    selection?: BenchlingSelection;
  }): void {
    const {text, formats} = e;
    this.setIntro(text, formats);
    this.props.requestSelection({selection: selutil.getSelectionIndices(e)});
  },

  pasteHandler(
    e: SelectionPartition & {
      originalEvent: ElementClipboardEvent;
    }
  ): void {
    let part;
    const {before, selected, after, originalEvent} = e;
    const parts = wyciwyp.processClipboard(originalEvent.clipboardData);
    const oldFormats = this.props.protocol.descriptionFormats;
    const beforeFormats = formatters.splitFormats(oldFormats, before.length).before;
    const afterFormats = formatters.splitFormats(oldFormats, before.length + selected.length).after;

    const text =
      before +
      (() => {
        const result = [];
        for (part of Array.from(parts)) {
          result.push(part.text);
        }
        return result;
      })().join('\n') +
      after;
    let offset = before.length;
    let newFormats = beforeFormats;
    for (let i = 0; i < parts.length; i++) {
      part = parts[i];
      newFormats = formatters.joinFormats(newFormats, part.formats, offset);
      offset += (part.text as string).length;
      if (i !== parts.length - 1) {
        offset += 1; // for the new line
      }
    }

    newFormats = formatters.joinFormats(newFormats, afterFormats, offset);
    const pos = text.length - after.length;
    this.setIntro(text, newFormats);
    this.props.requestSelection({selection: {cid: this.props.cid, start: pos, end: pos}});
  },

  splitHandler(e: {
    before: string;
    after: string;
    afterPoint: boolean;
    selected: string;
    modifierKey: boolean;
    shiftKey: boolean;
    originalEvent: ElementKeyboardEvent;
  }): void {
    const {before, selected, after} = e;
    const oldFormats = this.props.protocol.descriptionFormats;
    const beforeFormats = formatters.splitFormats(oldFormats, before.length).before;
    const afterFormats = formatters.splitFormats(oldFormats, before.length + selected.length).after;
    const text = `${before}\n${after}`;
    const newFormats = formatters.joinFormats(beforeFormats, afterFormats, before.length + 1);
    const pos = before.length + 1;
    this.setIntro(text, newFormats);
    this.props.requestSelection({selection: {cid: this.props.cid, start: pos, end: pos}});
  },

  getInitialState(): IntroEditorState {
    return {
      index: 0,
    };
  },

  render(): JSX.Element {
    return (
      <div className="intro-editor" data-editor={this.props.editorKey}>
        <IntroEditable
          cid={this.props.cid}
          text={this.props.protocol.description}
          index={this.state.index}
          formats={this.props.protocol.descriptionFormats}
          formatHandler={this.props.formatHandler.bind(null, this.state.index)}
          moveHandler={this.moveHandler}
          updateHandler={this.updateHandler}
          pasteHandler={this.pasteHandler}
          splitHandler={this.splitHandler}
          storeState={this.props.storeState}
          restoreState={this.props.restoreState}
          locked={this.props.locked}
          spellCheck={this.props.spellCheck}
        />
      </div>
    );
  },
});

export default IntroEditor;
